import React, { useState } from 'react';
import GenericModal from '@ui-components/Modal/GenericModal';
import GenericSelect from '@ui-components/Select/GenericSelect';
import GenericInput from '@ui-components/Input/GenericInput';
import GenericButton from '@ui-components/Button/GenericButton';

const cloudProviders = [
  { value: 'aws', label: 'Amazon Web Services (AWS)' },
  { value: 'azure', label: 'Microsoft Azure' },
  { value: 'gcp', label: 'Google Cloud Platform' },
];

const licenseSKUs = [
  { value: 'AWS-TELCO-TYR-LICENSE', label: 'AWS-TELCO-TYR-LICENSE' },
  { value: 'AZURE-TELCO-TYR-LICENSE', label: 'AZURE-TELCO-TYR-LICENSE' },
];

const LICENSE_PRICES: Record<string, string> = {
  'AWS-TELCO-TYR-LICENSE': '€2,499',
  'AZURE-TELCO-TYR-LICENSE': '€2,499',
};

interface LicenseModalProps {
  isOpen?: boolean;
  onClose: () => void;
}

const LicenseModal: React.FC<LicenseModalProps> = ({ isOpen = true, onClose }) => {
  const [cloudProvider, setCloudProvider] = useState(cloudProviders[0].value);
  const [licenseSKU, setLicenseSKU] = useState(licenseSKUs[0].value);
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvc, setCvc] = useState('');

  const price = LICENSE_PRICES[licenseSKU] || '€2,499';

  return (
    <GenericModal isOpen={isOpen} onClose={onClose} title={
      <div className="flex items-center gap-2">
        <span className="text-xl font-semibold">Purchase CTX Reflector license</span>
      </div>
    } size="lg">
      <div className="text-sm text-semantic-text-secondary mb-4">
        Select your cloud provider and license type to purchase a CTX Reflector license.
      </div>
      <div className="flex flex-col gap-4">
        <GenericSelect
          label="Cloud provider"
          options={cloudProviders}
          defaultValue={cloudProvider}
          onSelect={setCloudProvider}
          widthClass="w-full"
          maxWidthClass="w-full"
        />
        <GenericSelect
          label="License SKU"
          options={licenseSKUs}
          defaultValue={licenseSKU}
          onSelect={setLicenseSKU}
          widthClass="w-full"
          maxWidthClass="w-full"
        />
        <div className="rounded bg-semantic-bg-secondary border border-semantic-bg-tertiary p-4 flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <span className="font-medium text-semantic-text-primary">Selected license</span>
            <span className="font-medium text-semantic-text-primary">Price</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-semantic-text-secondary">{licenseSKU}</span>
            <span className="font-semibold text-lg">{price}</span>
          </div>
        </div>
        <GenericInput
          label="Card holder name"
          placeholder="John Smith"
          value={cardName}
          onChange={setCardName}
        />
        <div className="flex gap-4">
          <GenericInput
            label="Card number"
            placeholder="4242 4242 4242 4242"
            value={cardNumber}
            onChange={setCardNumber}
            icon={<svg className="w-5 h-5 text-semantic-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="10" rx="2" strokeWidth="2" /><path d="M2 11h20" strokeWidth="2" /></svg>}
          />
          <GenericInput
            label="Expiry date"
            placeholder="MM/YY"
            value={expiry}
            onChange={setExpiry}
          />
          <GenericInput
            label="CVC"
            placeholder="123"
            value={cvc}
            onChange={setCvc}
          />
        </div>
        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded p-3">
          <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 17v.01" /><rect x="3" y="5" width="18" height="14" rx="2" strokeWidth="2" /><path d="M3 7h18" strokeWidth="2" /></svg>
          <span className="text-blue-700 text-sm">Your payment information is secure and encrypted.</span>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <GenericButton label="Cancel" variant="secondary" onClick={onClose} />
          <GenericButton label="Purchase license" variant="brand" />
        </div>
      </div>
    </GenericModal>
  );
};

export default LicenseModal;